import { render } from "./TabPane.vue?vue&type=template&id=79a3c158&scoped=true"
import script from "./TabPane.vue?vue&type=script&lang=js"
export * from "./TabPane.vue?vue&type=script&lang=js"

import "./TabPane.vue?vue&type=style&index=0&id=79a3c158&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79a3c158"],['__file',"src/components/mdbvue/Components/TabPane.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "79a3c158"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('79a3c158', __exports__)) {
    api.reload('79a3c158', __exports__)
  }
  
  module.hot.accept("./TabPane.vue?vue&type=template&id=79a3c158&scoped=true", () => {
    api.rerender('79a3c158', render)
  })

}


export default __exports__